import React, { useContext } from 'react';
import { navigateV2 } from '../../../common/utils/router';
import UserContext, { StoreContext } from '../../../common/utils/getContext';
import T from '../../../common/components/T';
import css from './CartFooter.module.scss';
import SingleButton from '../../form/form-control-buttons/SingleButton/SingleButton';

const CartFooter = ({ total, total_marketing, type = 'cart' }) => {
    const { userToken } = useContext(UserContext);
    const { setShowRegWindow } = useContext(StoreContext);
    return (
        <div style={type === 'checkout' ? { justifyContent: 'flex-end' } : {}} className={css.cartFooter}>
            {/* {!screenWidth && type === 'cart' && (
                <div>
                    <div className={css.buttonSecondary} onClick={() => setCart(!cart)}>
                        {svgSprite('arrow-left', {
                            width: 20,
                            height: 14,
                            fill: 'var(--blueColor)'
                        })}
                        <div style={{ marginLeft: '12px' }}>
                            <T textName='storeContinieProduct' defaultStr='Продолжить покупки' page='/store' />
                        </div>
                    </div>
                </div>
            )} */}
            <div className={css.cartFooterMobile}>
                <div>
                    {/* <div className={css.cartItemSubtitle}>
                        <T textName='storeTotalPrice' defaultStr='Всего на сумму' page='/store' />:
                    </div> */}
                    <div className={css.cartFooterMobilePrice}>
                        <div className={css.totalPriceRow}>
                            <p className={css.totalPriceRowLabel}>
                                <T textName='order-price' defaultStr='Сумма заказа' page='/store' />:
                            </p>
                            <div className={css.totalPriceRowLine}></div>
                            <p className={css.totalPriceMedium}>{total}</p>
                        </div>
                        <div className={css.totalPriceRow}>
                            <p className={css.totalPriceRowLabel}>
                                <T textName='points-per-order' defaultStr='Баллов за заказ' page='/store' />:
                            </p>
                            <div className={css.totalPriceRowLine}></div>
                            <p className={css.totalMarketingPrice}>{total_marketing ? total_marketing : 0}</p>
                        </div>
                    </div>
                </div>
                {type === 'cart' && (
                    <SingleButton
                        type='ok'
                        buttonText={<T textName='storeOrderCreate' defaultStr='Оформить заказ' page='/store' />}
                        clickFunc={() => {
                            if (!userToken && 0) {
                                setShowRegWindow(true);
                            } else {
                                navigateV2('/store/cart');
                            }
                        }}
                    />
                )}
            </div>
        </div>
    );
};
export default CartFooter;
